import { Button } from "reactstrap";
import './Default.css';
import { ImSpinner8 } from "react-icons/im";

function IconButton({
  children, 
  color, 
  onClick, 
  loading,
  ...props
}) {
  return(
    <Button {...props} color={color || 'primary'} onClick={onClick} className={`${props.className}`}>
      {loading ?
        <ImSpinner8 className="animation-spin" />
      :
        children
      }
    </Button>
  );
}

export default IconButton;